function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CalendarIcon from "@digital-hig/icon/lib/esm/icons/calendar";
import CaretDown from "@digital-hig/icon/lib/esm/icons/caret-down";
import CaretLeft from "@digital-hig/icon/lib/esm/icons/caret-left";
import CaretRight from "@digital-hig/icon/lib/esm/icons/caret-right";
export var makeDatePickerStyles = function makeDatePickerStyles(_ref) {
  var primitives = _ref.primitives,
    tokens = _ref.tokens;
  return {
    MuiDatePicker: {
      defaultProps: {
        reduceAnimations: true,
        slots: {
          openPickerIcon: CalendarIcon,
          leftArrowIcon: CaretLeft,
          rightArrowIcon: CaretRight,
          switchViewIcon: CaretDown
        },
        slotProps: {
          field: {
            shouldRespectLeadingZeros: true,
            sx: {
              "& [class*='MuiOutlinedInput-input']": {
                color: tokens.colors["ink-on-background"],
                "&::placeholder": {
                  color: tokens.colors["ink-on-background-60"]
                }
              }
            }
          },
          desktopTransition: {
            easing: primitives.transitions.easing["slow-down"],
            timeout: parseFloat(primitives.transitions.duration["3"])
          }
        }
      }
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        root: {
          "& [class*='MuiButtonBase-root']": {
            "&:active": {
              backgroundColor: tokens.colors["pressed-fill-subtle"]
            },
            borderRadius: "50%",
            "& svg": {
              color: tokens.colors["ink-on-background"],
              height: primitives.spacings["5"],
              width: primitives.spacings["5"]
            }
          },
          "& [class*='MuiPickersArrowSwitcher-button']": {
            "&:focus-visible": {
              boxShadow: tokens.effects["focus-ring-thin"]
            },
            "&.Mui-disabled": {
              opacity: tokens.opacities["disabled"]
            }
          },
          "& [class*='MuiPickersArrowSwitcher-spacer']": {
            width: primitives.spacings["7"]
          },
          marginTop: primitives.spacings["6"],
          paddingRight: primitives.spacings["6"]
        },
        label: {
          fontWeight: primitives.fontWeights.stout
        },
        labelContainer: {
          padding: primitives.spacings["1"]
        },
        switchViewButton: {
          "&:focus-visible": {
            boxShadow: tokens.effects["focus-ring-thin"]
          }
        }
      }
    },
    MuiDateCalendar: {
      styleOverrides: {
        root: {
          height: "unset",
          maxHeight: "fit-content"
        }
      }
    },
    MuiDayCalendar: {
      styleOverrides: {
        header: {
          paddingLeft: primitives.spacings["6"],
          paddingRight: primitives.spacings["6"]
        },
        monthContainer: {
          position: "relative",
          "&[class*='slideExit']": {
            display: "none"
          }
        },
        weekContainer: {
          padding: "0 ".concat(primitives.spacings["6"]),
          margin: "".concat(primitives.spacings["1"], " 0"),
          "&:last-of-type": {
            marginBottom: primitives.spacings["0"],
            paddingBottom: primitives.spacings["6"]
          }
        },
        weekDayLabel: _objectSpread({
          color: tokens.colors["ink-on-background-60"],
          margin: "".concat(primitives.spacings["1"], " 2px 0px 0px")
        }, tokens.typography["short-copy-medium"]),
        slideTransition: {
          overflowX: "unset",
          minHeight: "unset"
        }
      }
    },
    MuiPickersDay: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({
          color: tokens.colors["ink-on-background"]
        }, tokens.typography["short-copy-medium"]), {}, {
          margin: "2px",
          marginLeft: "".concat(primitives.spacings["0"]),
          "&.Mui-selected": {
            fontWeight: primitives.fontWeights.default,
            boxShadow: tokens.effects["focus-ring-reverse"],
            "&:focus": {
              boxShadow: tokens.effects["focus-ring-reverse"]
            },
            "&:not(:focus)": {
              boxShadow: "none"
            },
            "&:hover": {
              boxShadow: tokens.effects["halo-hover"]
            },
            "&:active:focus": {
              boxShadow: tokens.effects["halo-pressed"],
              backgroundColor: tokens.colors["fill-primary"]
            }
          },
          "&:focus": {
            backgroundColor: primitives.colors.detail.transparent,
            boxShadow: tokens.effects["focus-ring-thin"]
          },
          "&:focus:active": {
            backgroundColor: tokens.colors["pressed-fill-subtle"],
            boxShadow: "none"
          }
        }),
        today: {
          border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["ink-on-background"]),
          "&:not(.Mui-selected)": {
            border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["ink-on-background"]),
            "&:focus": {
              boxShadow: tokens.effects["focus-ring-reverse"],
              backgroundColor: "transparent"
            },
            "&:focus:active": {
              backgroundColor: tokens.colors["pressed-fill-subtle"],
              boxShadow: "none"
            }
          }
        }
      }
    },
    MuiPickersYear: {
      styleOverrides: {
        yearButton: {
          "&.Mui-selected": {
            "&:focus-visible": {
              boxShadow: tokens.effects["focus-ring-reverse"]
            },
            "&:active:focus": {
              boxShadow: tokens.effects["halo-pressed"]
            },
            "&:hover": {
              boxShadow: tokens.effects["halo-hover"]
            }
          },
          "&:not(.Mui-selected)": {
            "&:focus": {
              backgroundColor: primitives.colors.detail.transparent,
              boxShadow: tokens.effects["focus-ring-thin"]
            },
            "&:active": {
              backgroundColor: tokens.colors["pressed-fill-subtle"],
              boxShadow: "none"
            }
          },
          "&.Mui-disabled": {
            color: tokens.colors["ink-on-background-disabled"]
          }
        }
      }
    },
    MuiPickersPopper: {
      styleOverrides: {
        root: {
          borderTopLeftRadius: primitives.borderRadii.none,
          borderTopRightRadius: primitives.borderRadii.none,
          borderBottomLeftRadius: primitives.borderRadii.medium,
          borderBottomRightRadius: primitives.borderRadii.medium
        },
        paper: {
          color: tokens.colors["ink-on-background"],
          marginTop: primitives.spacings["1"],
          borderTopLeftRadius: primitives.borderRadii.none,
          borderTopRightRadius: primitives.borderRadii.none,
          boxShadow: tokens.effects["elevation-0-dropdown"]
        }
      }
    },
    MuiPickersLayout: {
      styleOverrides: {
        root: {
          "& [class*='MuiPickersLayout-contentWrapper']": {
            overflowX: "clip"
          },
          "& [class*='MuiPickersArrowSwitcher-button']": {
            color: tokens.colors["ink-on-background"],
            borderRadius: "100vmax"
          },
          "& [class*='MuiPickersLayout-toolbar']": {
            "& [class*='MuiTypography-root']": {
              color: tokens.colors["ink-on-background"]
            },
            padding: "".concat(primitives.spacings["6"], " ").concat(primitives.spacings["6"], " ").concat(primitives.spacings["2"], " ").concat(primitives.spacings["6"])
          },
          "& [class*='MuiPickersLayout-actionBar']": {
            padding: "".concat(primitives.spacings["0"], " ").concat(primitives.spacings["6"], " ").concat(primitives.spacings["6"]),
            "& [class*='MuiButtonBase-root']:first-of-type": _objectSpread(_objectSpread({}, tokens.button["outlined"]["defaultSize"].default), {}, {
              "&:hover": _objectSpread({}, tokens.button["outlined"]["defaultSize"].hover),
              "&:focus": _objectSpread({}, tokens.button["outlined"]["defaultSize"].focus),
              "&:focus:active": _objectSpread({}, tokens.button["outlined"]["defaultSize"].pressed),
              "&:active": _objectSpread({}, tokens.button["outlined"]["defaultSize"].pressed)
            })
          },
          margin: "2px 2px 0 2px"
        }
      }
    },
    MuiDateRangeCalendar: {
      styleOverrides: {
        monthContainer: {
          "& [class*='MuiDayCalendar-header']": {
            justifyContent: "space-between"
          }
        }
      }
    },
    MuiDateRangePickerDay: {
      styleOverrides: {
        rangeIntervalDayHighlight: {
          backgroundColor: tokens.colors["activated-fill-subtle"]
        },
        outsideCurrentMonth: {
          backgroundColor: primitives.colors.detail.transparent
        }
      }
    }
  };
};